import { Transition, TransitionService } from '@uirouter/core';
import { IBreadCrumb, IRootScope } from '../../tn.common';

export function getTransitionBreadcrumbs(
    transition: Transition
): IBreadCrumb[] {
    let state = transition.targetState().$state();
    const $breadcrumbs: IBreadCrumb[] = [];

    // walk the state tree back up to the root.
    while (state && state.navigable) {
        try {
            const title = transition.injector(state).get('$title');

            const breadcrumb: IBreadCrumb = {
                title,
                state: state.self.name,
                stateParams: state.params,
            };
            $breadcrumbs.unshift(breadcrumb);
        } catch (error) {
            // suppress errors when title is not defined for a given state.
        }

        state = state.parent;
    }
    return $breadcrumbs;
}

export function runTitleUpdates(
    $rootScope: IRootScope,
    $transitions: TransitionService
): void {
    $transitions.onSuccess({}, function (transition) {
        $rootScope.$breadcrumbs = getTransitionBreadcrumbs(transition);
        $rootScope.$title = $rootScope.$breadcrumbs
            .map((b) => b.title)
            .reverse()
            .join(' · ');
        if ($rootScope.$title) {
            document.title = $rootScope.$title;
        }
    });
}
runTitleUpdates.$inject = ['$rootScope', '$transitions'];
